var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Container } from "react-bootstrap";
var SimpleApp = /** @class */ (function (_super) {
    __extends(SimpleApp, _super);
    function SimpleApp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleApp.prototype.render = function () {
        return (React.createElement(Container, null,
            React.createElement(BrowserRouter, { basename: process.env.PUBLIC_URL },
                this.props.navbar,
                React.createElement(Switch, null, this.props.routes.map(function (route) { return (React.createElement(Route, { exact: true, path: route.path }, route.page)); })))));
    };
    return SimpleApp;
}(Component));
export { SimpleApp };
//# sourceMappingURL=SimpleApp.js.map